module.exports = __webpack_public_path__ + "img/unlink.e3113c9d.svg";